import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBClassSetup } from "../../components/WSIBClassSetup";

export const WSIBClassSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Class Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Class Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBClassSetup />}
    />
  );
};
